import { createToken, deleteToken, getTokens } from '@/services/api/tokens.api';

const state = {
  tokens: [],
  status: '',
};

const mutations = {
  tokens_request(state) {
    state.status = 'loading';
  },
  tokens_success(state, tokens) {
    state.status = 'success';
    state.tokens = tokens;
  },
  tokens_add(state, token) {
    state.tokens.push(token); // token has no client_secret
  },
  tokens_delete_success(state, deletedToken) {
    state.tokens = state.tokens.filter(
      (token) => token.token_uuid !== deletedToken.token_uuid
    );
  },
};

const actions = {
  fetchTokens({ commit }) {
    commit('tokens_request');
    return getTokens()
      .then((tokens) => {
        // Back-end should NOT return secrets here
        commit('tokens_success', tokens);
      })
      .catch((error) => {
        this.commit('showNotification', {
          content: error.message,
          color: 'error',
        });
      });
  },

  // Returns full payload (incl. plain secret) to the caller,
  // but only commits non-secret fields into state.
  async createToken({ commit }, tokenInput) {
    try {
      const payload = await createToken(tokenInput);
      const toStore = {
        client_id: payload.client_id,
        token_uuid: payload.token_uuid,
        app_name: payload.app_name,
      };
      commit('tokens_add', toStore);
      return payload; // caller will open the "show once" dialog
    } catch (error) {
      this.commit('showNotification', {
        content: error.message,
        color: 'error',
      });
      throw error;
    }
  },

  deleteToken({ commit }, tokenToDelete) {
    return deleteToken(tokenToDelete)
      .then(() => {
        commit('tokens_delete_success', tokenToDelete);
      })
      .catch((error) => {
        this.commit('showNotification', {
          content: error.message,
          color: 'error',
        });
      });
  },
};

const getters = {
  tokens: (state) => state.tokens,
  tokenStatus: (state) => state.status,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
